window.PauseItReviews = {
  products: {
    "sleep-aid-patch": [
      { quote: "Good product. Sleep was better from the second night.", name: "Hira Siddiqui", city: "Sialkot", rating: 5 },
      { quote: "Nice patch. Delivery was also fast.", name: "Mehreen Ali", city: "Islamabad", rating: 5 },
      { quote: "It was good. I slept properly after a long time.", name: "Fatima Ahmed", city: "Lahore", rating: 5 },
      { quote: "Quality is fine. A bit sticky but worked for me.", name: "Ayesha Khan", city: "Gujranwala", rating: 4 }
    ],
    "menstrual-cramp-relief-patch": [
      { quote: "Really good for cramps. Pain went down a lot.", name: "Iqra Hussain", city: "Peshawar", rating: 5 },
      { quote: "Nice product. Kept it under my clothes the whole day.", name: "Maham Javed", city: "Multan", rating: 5 },
      { quote: "It helped. First day was still bad but second day better.", name: "Sana Iqbal", city: "Faisalabad", rating: 4 },
      { quote: "Good quality. Delivery time was also good.", name: "Laiba Raza", city: "Lahore", rating: 5 }
    ],
    "motion-sickness-patch": [
      { quote: "Used it on the bus. No vomiting. Good.", name: "Bushra Khan", city: "Karachi", rating: 5 },
      { quote: "Nice patch. Travel was comfortable.", name: "Rida Hassan", city: "Rawalpindi", rating: 5 },
      { quote: "It was okay. Helped a bit with the dizziness.", name: "Amna Sheikh", city: "Islamabad", rating: 4 },
      { quote: "Good product for long drive. Packaging was fine.", name: "Omar Farooq", city: "Lahore", rating: 5 }
    ],
    "tinnitus-treatment-patch": [
      { quote: "Ringing is a bit less. Not fully gone but better.", name: "Sidra Amin", city: "Sahiwal", rating: 4 },
      { quote: "Good product. Using it at night only.", name: "Hareem Malik", city: "Quetta", rating: 5 },
      { quote: "It was nice. Delivery came on time.", name: "Anum Fatima", city: "Karachi", rating: 5 },
      { quote: "Quality is good. Will order again.", name: "Bisma Noor", city: "Hyderabad", rating: 4 }
    ],
    "cough-relief-patch": [
      { quote: "Cough was better by morning. Good patch.", name: "Zainab Noor", city: "Gujranwala", rating: 5 },
      { quote: "Bought for my mother. She said it is nice.", name: "Emaan Ali", city: "Lahore", rating: 5 },
      { quote: "Good for night cough. Kids slept better.", name: "Rabia Khan", city: "Faisalabad", rating: 5 },
      { quote: "It was fine. Better than syrup for me.", name: "Ali Raza", city: "Sialkot", rating: 4 }
    ],
    "constipation-relief-patch": [
      { quote: "It worked. Felt lighter next day.", name: "Sobia Akhtar", city: "Sahiwal", rating: 5 },
      { quote: "Good product. No side effect for me.", name: "Farah Qureshi", city: "Rawalpindi", rating: 5 },
      { quote: "Nice. Delivery was quick also.", name: "Kinza Ahmed", city: "Multan", rating: 5 },
      { quote: "It was okay. Took two days to notice.", name: "Saima Bibi", city: "Bahawalpur", rating: 4 }
    ],
    "diabetic-patch": [
      { quote: "Bought for Abbu. He said it is good.", name: "Bushra Khan", city: "Karachi", rating: 5 },
      { quote: "Easy to use. Quality looks fine.", name: "Maryam Saeed", city: "Peshawar", rating: 5 },
      { quote: "Nice product. Using with his normal medicine.", name: "Hafsa Imran", city: "Lahore", rating: 4 },
      { quote: "Good delivery and packaging. Father is using daily.", name: "Usman Raza", city: "Faisalabad", rating: 5 }
    ],
    "multi-vitamin-topical-patch": [
      { quote: "Good alternative to tablets. Easy to wear.", name: "Dua Zahra", city: "Quetta", rating: 5 },
      { quote: "Nice quality. I feel a bit more energetic.", name: "Areeba Malik", city: "Islamabad", rating: 5 },
      { quote: "It was good. No smell, sticks well.", name: "Alishba Noor", city: "Lahore", rating: 5 },
      { quote: "Okay product. Delivery time was good.", name: "Mahnoor Ali", city: "Rawalpindi", rating: 4 }
    ],
    "dental-guards": [
      { quote: "Good for grinding. Jaw pain is less.", name: "Nadia Butt", city: "Mardan", rating: 5 },
      { quote: "Nice product. Fit was okay after trimming.", name: "Sara Malik", city: "Islamabad", rating: 5 },
      { quote: "It was fine. Packaging was good also.", name: "Khadija Omar", city: "Karachi", rating: 4 }
    ],
    "v-shape-face-mask": [
      { quote: "Nice mask. Face looked a bit fresh after.", name: "Noor Fatima", city: "Lahore", rating: 5 },
      { quote: "Good quality. Easy to wear.", name: "Ayesha Rehman", city: "Hyderabad", rating: 4 },
      { quote: "It was okay. Used before a function.", name: "Bisma Khan", city: "Multan", rating: 5 }
    ],
    "starter-kit": [
      { quote: "Good kit to try first. Quality is nice.", name: "Hira Qureshi", city: "Lahore", rating: 5 },
      { quote: "Nice packaging. Delivery was also fast.", name: "Mehreen Shah", city: "Islamabad", rating: 5 },
      { quote: "It was good. Will order the ones I liked again.", name: "Sidra Khan", city: "Karachi", rating: 4 }
    ],
    "mymi-wonder-patch": [
      { quote: "Good for bloating. Clothes sat better.", name: "Farah Siddiqui", city: "Lahore", rating: 5 },
      { quote: "Nice patch. No irritation for me.", name: "Iqra Malik", city: "Rawalpindi", rating: 4 },
      { quote: "It was fine. Delivery came on time.", name: "Sana Sheikh", city: "Karachi", rating: 5 }
    ]
  }
};

(function () {
  var catalog = window.PauseItReviews;
  if (!catalog || !catalog.products) return;
  catalog.all = [];
  Object.keys(catalog.products).forEach(function (handle) {
    catalog.products[handle].forEach(function (review) {
      catalog.all.push(Object.assign({ product: handle }, review));
    });
  });
})();
